export const theme = {
  colors: {
    brand50: "#f4f0ff",
    brand100: "#e3d8fe",
    brand200: "#c2aefd",
    brand300: "#a187fc",
    brand400: "#8b6ffb",
    brand500: "#875af9",
    brand600: "#7046d3",
    brand700: "#5a39a9",
    brand800: "#452b7f",
    brand900: "#2f1e55",
    brandBackground: "hsla(257, 93%, 66%, 0.3)",
    brandText: "#3d207a",
    white: "#fff",
  },
  fonts: {
    sans: "Inter, sans-serif",
  },
};
